import React, { FunctionComponent } from 'react';
import { Modal as BootstrapModal } from 'react-bootstrap';

import { FormValues as FormValuesForConfirmation } from '../views/FundingRequestStep';
import { Button, Modal, Text } from '@tradingblock/components';
import FundingRequestReview from './FundingRequestReview';
import { AchRelationship } from '@tradingblock/types';

interface FundingRequestConfirmationModalProps {
  formValuesForConfirmation: FormValuesForConfirmation;
  closeModal: () => void;
  show: boolean;
  onSubmit: () => void;
  achRelationship: AchRelationship;
};

const FundingRequestConfirmationModal: FunctionComponent<FundingRequestConfirmationModalProps> = ({
  formValuesForConfirmation,
  closeModal,
  onSubmit,
  show,
  achRelationship
}) => (
  <Modal setShow={closeModal} show={show} backdrop="static" className="service-level-modal">
    <BootstrapModal.Header>
      <BootstrapModal.Title>
        <Text id="fundingRequestConfirmationModal.fundingRequestConfirmation" />
      </BootstrapModal.Title>
    </BootstrapModal.Header>
    <BootstrapModal.Body>
      <p><Text id="fundingRequestConfirmationModal.confirmDetails" /></p>
      <FundingRequestReview transferFormData={formValuesForConfirmation} achRelationship={achRelationship} />
    </BootstrapModal.Body>
    <BootstrapModal.Footer>
      <Button className="btn-secondary" onClick={closeModal}><Text id="btns.cancel" /></Button>
      <Button className="btn-primary" onClick={onSubmit}><Text id="btns.submitFundingRequest" /></Button>
    </BootstrapModal.Footer>
  </Modal>
);

export default FundingRequestConfirmationModal;
